// extracted by mini-css-extract-plugin
export default {"TechWork":"TechWork_TechWork__OS-Qx","close":"TechWork_close__Wz0qh","holder":"TechWork_holder__DpRR8","text_holder":"TechWork_text_holder__U7vvU"};